export const moongyMenuConfig = {
  additionalItems: [],
  hideItems: [],
  modifyItems: [],
};
